import { toast } from "react-toastify";
import { useLazyGetInvoiceAttachmentQuery } from "../services/invoices/InvoiceApiSlice";
import { DocumentEntry } from "../utils/types";
import { formatIndianCurrency } from "../utils/utils";

const useAddEntryForm = () => {
  const [triggerGetInvoiceAttachment] = useLazyGetInvoiceAttachmentQuery();

  const validateForm = (formData: any): string[] => {
    const errors: string[] = [];

    // Attachment validation
    if (!formData.attachment && !formData.existingAttachmentName) {
      errors.push("Kindly upload Invoice Document File.");
    }

    if (formData.vendor_code === '' && formData?.isPoModuleSelected === "No") errors.push("Vendor is required.");
    if (!formData.throughGEM && formData.isPoModuleSelected === "Yes") errors.push("Through GEM is required.");
    if (!formData.assignedTo && formData?.isPoModuleSelected === "No") errors.push("Assigned To is required.");
    if (!formData.billType && formData?.isPoModuleSelected !== "No") errors.push("Invoice Type is required.");
    if (!formData.billCategory) errors.push("Invoice Category is required.");
    if (!formData.grossAmount) errors.push("Gross Amount is required.");
    if (!formData.procurementType && formData.isPoModuleSelected === "Yes") errors.push("Procurement Type is required.");
    if (!formData.poContract && formData?.isPoModuleSelected !== "No") errors.push("PO/Contract is required.");
    if (!formData.invoiceForWhichLocation) errors.push("Invoice for which location is required.");
    if (!formData.divisionName) errors.push("Division Name is required.");
    if (!formData.billDate) errors.push("Invoice Date is required.");

    if (formData?.remarks !== '' && /<\/?[a-z][\w-]*(\s+[^<>]*)?>/i.test(formData?.remarks)) {
      errors.push("HTML tag are not allow in remarks.");
    }

    const today = new Date(); // current date
    const futureDate = new Date(formData.billDate); // your future date

    if (futureDate > today) {
      errors.push("Future date not allow.");
    }

    if (!formData.totalTax) errors.push("Total Tax is required.");
    if (!formData.billAmount) errors.push("Invoice Amount is required.");
    if (!formData.billNo) errors.push("Invoice No. is required.");
    if (!formData.netPayable) errors.push("Net Payable is required.");
    if (formData.remarks?.length > 500) errors.push("Remarks should be max 500 characters.");
    if (Number(formData?.advanceAdj.replace(/,/g, "")) > Number(formData?.billAmount.replace(/,/g, ""))) errors.push("Advance Adj. value cannot be greater than Invoice Amount");

    if (["gem", "tender_wizard", "nic"].includes(formData.throughGEM?.toLowerCase()) && !formData.gemContactNo) {
      errors.push("GEM Contract No. is required when Through Portal is selected.");
    }

    // Document validation
    // formData.documents.forEach((doc) => {
    //   if (!doc.file && !doc.existingFileName) {
    //     errors.push(`${doc.description} document is required.`);
    //   }
    // });

    return errors;
  };

  const initialDocumentsData: DocumentEntry[] = [
    {
      id: "lab",
      description: "Labor License",
      file: null,
      preview: null,
      existingFileName: null,
    },
    {
      id: "wrk",
      description: "Work Completion Certificate",
      file: null,
      preview: null,
      existingFileName: null,
    },
  ];

  const handleCurrencyOnBlur = (e, setFormData) => {
    const formatted = formatIndianCurrency(e.target.value);
    setFormData((prev) => ({ ...prev, [e.target.name]: formatted }));
  };

  const sectionHeaderStyles = {
    bgcolor: "primary.softBg",
    color: "primary.plainColor",
    p: 1.5,
    borderRadius: "sm",
    fontWeight: "lg",
  };

  const handleFileDownload = async (file_type: string, bts_no: any, othersAttachments: boolean, attachment: any) => {
    // var obj: any = {
    //   bts_no: bts_no,
    //   file_type: doc_type,
    // }

    var url = `?bts_no=${bts_no}&file_type=${file_type}`;
    if (othersAttachments) {
      url = `?bts_no=${bts_no}&file_type=${file_type}&othersAttachments=${othersAttachments}`;
    }
    try {
      const response = await triggerGetInvoiceAttachment(url).unwrap();
      const { data, file_name, mime_type, presigned_url } = response;

      // const byteCharacters = atob(presigned_url);
      // const byteNumbers = new Array(byteCharacters.length).fill(null).map((_, i) => byteCharacters.charCodeAt(i));
      // const byteArray = new Uint8Array(byteNumbers);
      // const blob = new Blob([byteArray], { type: mime_type });

      // const blobUrl = URL.createObjectURL(blob);

      // Open in new tab
      window.open(presigned_url, "_blank");

      // Clean up the URL after a short delay to allow the browser to load it
      setTimeout(() => {
        URL.revokeObjectURL(presigned_url);
      }, 1000);
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  };

  const onUploadedFileClick = (previewFile) => {
    if (previewFile instanceof File || previewFile instanceof Blob) {
      const blobUrl = URL.createObjectURL(previewFile);
      window.open(blobUrl, "_blank");
    } else if (typeof previewFile === "string" && previewFile.startsWith("blob:")) {
      window.open(previewFile, "_blank");
    } else {
      console.error("Invalid attachmentPreview", previewFile);
    }
  };

  return { validateForm, initialDocumentsData, sectionHeaderStyles, handleFileDownload, onUploadedFileClick, handleCurrencyOnBlur };
};

export default useAddEntryForm;
